
const digest = 'c85c7f3ebf775aaa8db390476d5d0b2a6e9a7c540c0fb8b815bf8193de2ffeb2';
const css = `._infoBlock_14r4e_1 {
  --callout-box-padding-block: var(--spacer-4);
  --callout-box-padding-inline: var(--spacer-4);
  --callout-box-margin-block: var(--spacer-2);
  --callout-box-border-radius: var(--spacer-1);
  --callout-box-icon-padding: var(--spacer-3);
  padding: var(--callout-box-padding-block) var(--callout-box-padding-inline);
  margin: var(--callout-box-margin-block) 0;
  border-radius: var(--callout-box-border-radius);
  display: flex;

  & > span {
    flex: 1 1 auto;
  }

  &:before {
    font-family: var(--fa-family-classic);
    font-weight: 400;
    padding-right: var(--callout-box-icon-padding);
    color: var(--callout-box-icon-color);
    content: var(--callout-box-icon-content);
    float: left;
  }
}

._infoBlockType_14r4e_26 {
  background-color: var(--theme-blue-background);
  border-color: var(--theme-blue-border);
  --callout-box-icon-color: var(--theme-blue-text);
  --callout-box-icon-content: '\\f05a';
  /* fa-info-circle */
  /* NOTE: Needs to be double escaped to work in app, but needs to be single escaped to work in playground. */
}

._noteBlockType_14r4e_35 {
  background-color: var(--theme-yellow-background);
  border-color: var(--theme-yellow-border);
  --callout-box-icon-color: var(--theme-yellow-text);
  --callout-box-icon-content: '\\f040';
  /* fa-pencil */
  /* NOTE: Needs to be double escaped to work in app, but needs to be single escaped to work in playground. */
}

._warningBlockType_14r4e_44 {
  background-color: var(--theme-red-background);
  border-color: var(--theme-red-border);
  --callout-box-icon-color: var(--theme-red-text);
  --callout-box-icon-content: '\\f071';
  /* fa-exclamation-triangle */
  /* NOTE: Needs to be double escaped to work in app, but needs to be single escaped to work in playground. */
}

._tipBlockType_14r4e_53 {
  background-color: var(--theme-green-background);
  border-color: var(--theme-green-border);
  --callout-box-icon-color: var(--theme-green-text);
  --callout-box-icon-content: '\\e2ca';
  /* fa-wand-magic-sparkles */
  /* NOTE: Needs to be double escaped to work in app, but needs to be single escaped to work in playground. */
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"infoBlock":"_infoBlock_14r4e_1","infoBlockType":"_infoBlockType_14r4e_26","noteBlockType":"_noteBlockType_14r4e_35","warningBlockType":"_warningBlockType_14r4e_44","tipBlockType":"_tipBlockType_14r4e_53"};
export { css, digest };
  